import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Container, Modal, Row, Col } from "react-bootstrap";
import AppFormCheck from "../../../../../application/components/app-form-check/AppFormCheck";
import { Country } from "../../../../../../shared/constants/Constant";
import { useFirestore, useFunctions } from "reactfire";
import WorkshopTag from "./components/workshop-tag/WorkshopTag";
import { BarLoader } from "react-spinners";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import { useHistory } from "react-router-dom";
import { DashboardPublicLibraryPages } from "../../containers/PublicLibrary";

interface IProps {
  show: boolean;
  activeList?: {
    libraryHome: boolean;
    workshopContent: boolean;
  };
  onHide?(): void;
}

export interface Workshop {
  id: string;
  title: string;
  description: string;
  createdAt: Date;
  country: Country;
  orderNo: number;
}

const PublicContentCopyModal = (props: IProps) => {
  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const store = useFirestore();
  const [country, setCountry] = useState<
    | "DEFAULT"
    | "SRI_LANKA"
    | "MALAYSIA"
    | "BOSNIA"
    | "JAMAICA"
    | "INDIA"
    | "INDONESIA"
  >("DEFAULT");
  const [fWorkshops, setFWorkshops] = useState<Workshop[]>([]);
  const [selectedWorkshops, setSelectedWorkshops] = useState<Workshop[]>([]);
  const [selectedWorkshop, setSelectedWorkshop] = useState<string>();
  const [copies, setCopies] = useState<{
    libraryHome: boolean;
    workshopContent: boolean;
  }>({ libraryHome: false, workshopContent: false });
  const [workshopListError, setWorkshopListError] = useState(false);

  useEffect(() => {
    if (props.show) {
      setFWorkshops([]);
      setSelectedWorkshops([]);
      setCountry("DEFAULT");
      setSelectedWorkshop(undefined);
      if (props.activeList) {
        setCopies(props.activeList);
      } else {
        setCopies({
          libraryHome: false,
          workshopContent: false,
        });
      }
    }
  }, [props.show, props.activeList]);

  useEffect(() => {
    if (!copies.workshopContent) setSelectedWorkshops([]);
  }, [copies.workshopContent]);

  useEffect(() => {
    const selectedCountry = country !== "DEFAULT";
    if (selectedCountry) {
      setFWorkshops((ps) => {
        return workshops
          .filter((w) => w.country === country)
          .sort((a: Workshop, b: Workshop) => a.orderNo - b.orderNo);
      });
    }
    setSelectedWorkshops([]);
    setSelectedWorkshop(undefined);
  }, [country, workshops]);

  useEffect(() => {
    return store
      .collection("workshops")
      .where("active", "==", true)
      .onSnapshot({}, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            setWorkshops((ps) => {
              ps.push({
                id: change.doc.id,
                title: change.doc.data().title,
                description: change.doc.data().description,
                createdAt: change.doc.data().createdAt,
                country: change.doc.data().country,
                orderNo: change.doc.data().orderNo,
              });
              return Object.assign([], ps);
            });
          }
          if (change.type === "modified") {
            setWorkshops((ps) => {
              const modified = ps.map((a) => {
                if (a.id === change.doc.id) {
                  return {
                    id: change.doc.id,
                    title: change.doc.data().title,
                    description: change.doc.data().description,
                    createdAt: change.doc.data().createdAt,
                    country: change.doc.data().country,
                    orderNo: change.doc.data().orderNo,
                  };
                } else {
                  return a;
                }
              });
              return Object.assign([], modified);
            });
          }
          if (change.type === "removed") {
            setWorkshops((ps) => {
              const removed = ps.filter((a) => a.id !== change.doc.id);
              return Object.assign([], removed);
            });
          }
        });
      });
  }, [store]);

  const selectWorkshop = (workshop: Workshop) => {
    setSelectedWorkshops((ps) => {
      if (ps.filter((w) => w.id === workshop.id).length === 0) {
        ps.push(workshop);
        setWorkshopListError(false);
      }
      return Object.assign([], ps);
    });
  };

  const deSelectWorkshop = (workshop: Workshop) => {
    setSelectedWorkshops((ps) => {
      ps = ps.filter((w) => w.id !== workshop.id);
      return Object.assign([], ps);
    });
  };
  const copyContentFunctionRef = useFunctions().httpsCallable(
    "copyToPublicLibrary"
  );
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();
  const copyWorkshop = () => {
    if (!(copies.libraryHome || copies.workshopContent)) {
      setWorkshopListError(true);
    } else {
      if (copies.workshopContent && selectedWorkshops.length === 0) {
        setWorkshopListError(true);
      } else {
        const data = {
          courseIntroduction: copies.libraryHome,
          workshops: copies.workshopContent,
          workshopIds: selectedWorkshops.map((w) => w.id),
          fromCountry: country,
        };

        setLoading(true);
        copyContentFunctionRef(data)
          .then(() => {
            UserNotification({
              isSuccess: true,
              message: "Content successfully Copied!",
            });
            if (props.onHide) props.onHide();
            setLoading(false);
            if (data.workshops) {
              push(DashboardPublicLibraryPages.PUBLIC_WORKSHOPS);
            } else {
              push(DashboardPublicLibraryPages.PUBLIC_HOME);
            }
          })
          .catch(() => {
            setLoading(false);
            UserNotification({
              isSuccess: false,
              message: `${country}
              ${props.activeList?.libraryHome ? "library home" : ""}
              ${
                props.activeList?.workshopContent ? "workshop" : ""
              } content is empty.`,
            });
          });
      }
    }
  };

  const getCountries = () => {
    return (
      <>
        <option value="MALAYSIA">Malaysia</option>
        <option value="SRI_LANKA">Sri Lanka</option>
        <option value="JAMAICA">Jamaica</option>
        <option value="BOSNIA">Bosnia and Herzegovina</option>
        <option value="INDIA">India</option>
        <option value="INDONESIA">Indonesia</option>
      </>
    );
  };

  return (
    <div className="copy-model-c">
      <Modal
        show={props.show}
        onHide={() => {}}
        centered
        size="xl"
        contentClassName="c-m-content"
      >
        <Modal.Body>
          <Container fluid className="workshop-copy-model">
            <Row>
              <Col xs={8}>
                <div className="d-flex align-items-center">
                  <label
                    className="form-label-m"
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      margin: "0px",
                    }}
                  >
                    Select a country to copy{" "}
                    {props.activeList?.libraryHome && "library home"}{" "}
                    {props.activeList?.workshopContent && "workshop contents"}
                  </label>
                </div>
              </Col>
              <Col xs={2}>
                {country !== "DEFAULT" && (
                  <button
                    className="app-button-outline text-right d-flex"
                    onClick={() => {
                      if (!loading) copyWorkshop();
                    }}
                  >
                    Copy
                  </button>
                )}
              </Col>
              <Col xs={2}>
                <button
                  className="app-button-outline d-flex text-right"
                  onClick={() => {
                    props.onHide && props.onHide();
                  }}
                  disabled={loading}
                >
                  Cancel
                </button>
              </Col>
            </Row>
            <div className="mt-3">
              <BarLoader
                height={4}
                width={"100%"}
                color={"#00629b"}
                loading={loading}
              />
            </div>
            <Row
              className="mt-2"
              style={{ paddingLeft: "100px", paddingRight: "100px" }}
            >
              <Col xs={12} className="d-flex">
                <div style={{ flex: 1 }}>
                  <div className="d-flex mt-3">
                    <label
                      className="form-label-m"
                      style={{
                        width: "110px",
                        flexShrink: 0,
                        flexGrow: 0,
                        fontSize: "16px",
                      }}
                    >
                      Copy from :
                    </label>
                    <div>
                      {/* "DEFAULT" | "SRI_LANKA" | "MALAYSIA" | "BOSNIA" | "JAMAICA" */}
                      <select
                        className="input-select"
                        style={{ width: "300px" }}
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value as any);
                        }}
                      >
                        <option value="DEFAULT" disabled hidden>
                          Country
                        </option>

                        {getCountries()}
                      </select>
                    </div>
                  </div>
                  {country !== "DEFAULT" && (
                    <div className="mt-3 d-none">
                      <div className="pr-2">
                        <AppFormCheck
                          label="Library home"
                          checked={copies.libraryHome}
                          type="checkbox"
                          onChange={(value) => {
                            setCopies({ ...copies, libraryHome: value });
                          }}
                        />
                      </div>
                      {fWorkshops.length !== 0 && (
                        <div className="px-2">
                          <AppFormCheck
                            label="Workshops content"
                            checked={copies.workshopContent}
                            type="checkbox"
                            onChange={(value) => {
                              setCopies({ ...copies, workshopContent: value });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {copies.workshopContent && (
                    <>
                      {country !== "DEFAULT" && (
                        <div className="d-flex mt-3">
                          <label
                            className="form-label-m"
                            style={{
                              width: "110px",
                              flexShrink: 0,
                              flexGrow: 0,
                              fontSize: "18px",
                            }}
                          >
                            workshops :
                          </label>
                          <div>
                            <select
                              className="input-select"
                              value={
                                selectedWorkshop ? selectedWorkshop : "select"
                              }
                              style={{ width: "300px" }}
                              onChange={(e) => {
                                setSelectedWorkshop(e.target.value);
                                const [workshop] = fWorkshops.filter(
                                  (w) => w.id === e.target.value
                                );
                                selectWorkshop(workshop);
                              }}
                            >
                              <option value="select" disabled hidden>
                                Select workshops
                              </option>
                              {fWorkshops.map((w, index) => (
                                <option key={index} value={w.id}>
                                  {w.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                      {selectedWorkshop && (
                        <div className="mt-3">
                          <label
                            className="form-label-m"
                            style={{
                              width: "190px",
                              flexShrink: 0,
                              flexGrow: 0,
                              fontSize: "18px",
                            }}
                          >
                            Selected workshops :
                          </label>
                          <div>
                            {selectedWorkshops.map((w, index) => (
                              <WorkshopTag
                                key={index}
                                workshop={w}
                                onClose={(w) => {
                                  deSelectWorkshop(w);
                                }}
                              />
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div>
                    {workshopListError && (
                      <label className="error-message">Invalid details</label>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PublicContentCopyModal;
